import { GameIntroBaseScene } from "src/games/shared/scenes/GameIntroBase";
import { Games } from "src/constants/Games";
import { HowToPlayScene } from "./IntroductionScene";

export class GameIntroScene extends GameIntroBaseScene {
    constructor() {
        super();
        this.gameRef = Games.GroceryBagger;
        this.howToPlayScene = HowToPlayScene;
        this.introTextKeys = [
            "GroceryBagger.Phaser.IntroductionScene.1",
            "GroceryBagger.Phaser.IntroductionScene.2",
        ];
    }
}



// WEBPACK FOOTER //
// ./src/games/GroceryBaggerGame/scenes/GameIntro.ts